"use client";

import Navigation from "@/components/layout/Navigation";
import Hero from "@/components/sections/Hero";
import CommercialGallery from "@/components/sections/CommercialGallery";
import Gallery from "@/components/sections/Gallery";
import Process from "@/components/sections/Process";
import About from "@/components/sections/About";
import SocialCard from "@/components/sections/SocialCard";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/Footer";

const IndexPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground theme-transition font-inter">
      <Navigation />
      <main>
        <Hero />
        <CommercialGallery />
        <Gallery />
        <Process />
        <About />
        <SocialCard />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default IndexPage;